const Contact = () => {

  const contactInfo = [
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      title: 'Visit Us',
      lines: ['500 30th Ave S, Appt 122', 'Moorhead, MN 56560'],
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      ),
      title: 'Call Us',
      lines: ['+1 (612) 360-6045', 'Mon-Fri 8am-5pm CST'],
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Email Us',
      lines: ['sucdisunshine@outlook.com', 'Response within 24 hours'],
    },
  ];

  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Header */}
      <section className="py-16 lg:py-24">
        <div className="section-container">
          <div className="max-w-3xl">
            <p className="text-primary font-semibold text-sm uppercase tracking-wider mb-3">Contact</p>
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              Let's Start a <span className="text-primary">Conversation</span>
            </h1>
            <p className="text-xl text-slate-400">
              Ready to transform your business? Schedule a consultation with our
              experts and discover how we can help you achieve your goals.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="pb-24">
        <div className="section-container">
          <div className="grid lg:grid-cols-5 gap-12">
            {/* Info */}
            <div className="lg:col-span-2 space-y-8">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-12 h-12 bg-dark-800 rounded-xl flex items-center justify-center text-primary flex-shrink-0">
                    {info.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1 font-sans">{info.title}</h3>
                    {info.lines.map((line, idx) => (
                      <p key={idx} className="text-slate-400 text-sm">{line}</p>
                    ))}
                  </div>
                </div>
              ))}

              <div className="pt-8 border-t border-white/5">
                <p className="text-slate-500 text-sm mb-4">Follow us</p>
                <div className="flex gap-3">
                  {['LinkedIn', 'Twitter', 'Facebook'].map((social) => (
                    <button
                      key={social}
                      className="w-10 h-10 bg-dark-800 rounded-full flex items-center justify-center text-slate-400 hover:text-primary hover:bg-dark-700 transition-colors"
                      aria-label={social}
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        {social === 'LinkedIn' && <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>}
                        {social === 'Twitter' && <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>}
                        {social === 'Facebook' && <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>}
                      </svg>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Form Placeholder */}
            <div className="lg:col-span-3">
              <div className="bg-dark-800 rounded-2xl p-6 lg:p-8 border border-white/5">
                <h3 className="text-xl font-semibold mb-4 font-sans">Get in Touch</h3>
                <p className="text-slate-400 mb-6">
                  We're currently setting up our contact form. In the meantime, please reach out to us directly using the contact information provided on this page.
                </p>
                <p className="text-slate-400 text-sm">
                  You can call us at <span className="text-primary">+1 (612) 360-6045</span> or email us at <span className="text-primary">sucdisunshine@outlook.com</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map placeholder */}
      <section className="pb-16">
        <div className="section-container">
          <div className="bg-dark-800 rounded-2xl h-64 lg:h-80 flex items-center justify-center border border-white/5">
            <div className="text-center">
              <svg className="w-12 h-12 text-slate-600 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <p className="text-slate-500">Moorhead, Minnesota</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
